import { render } from "./subjectlogin.vue?vue&type=template&id=a85e61e0"
import script from "./subjectlogin.js?vue&type=script&lang=js"
export * from "./subjectlogin.js?vue&type=script&lang=js"

import "./subjectlogin.vue?vue&type=style&index=0&id=a85e61e0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__